import * as actions from './actionTypes'

export const cookiedEnabledAction = (flag) => ({
  type: actions.COOKIES_ENABLED,
  payload: {
    description: flag,
  },
})

export const screenLoadingAction = () => ({
  type: actions.SCREEN_LOADING,
})

export const changeObjectPropertyAction = (object, field, value) => ({
  type: actions.CHANGE_OBJECT_PROPERTY,
  payload: {
    object,
    field,
    value
  }
})


export const currentAddressSameMedavieAction = (value) => ({
  type: actions.CURRENT_ADDRESS_SAME_MEDAVIE,
  payload: {
    value
  }
})


export const listAddAction = (listType, data) => ({
  type: actions.LIST_ADD,
  payload: {
    listType,
    data
  }
})

export const listEditAction = (listType, data) => ({
  type: actions.LIST_EDIT,
  payload: {
    listType,
    data
  }
})

export const setEditNSIdentifierNumber = (data) => ({
  type: actions.SET_EDIT_NS_IDENTIFIER_NUMBER,
  payload: {
    data
  }
})

export const setEditJointMasterNumber = (data) => ({
  type: actions.SET_EDIT_JOINT_MASTER_NUMBER,
  payload: {
    data
  }
})

export const setEditBusinessMasterNumber = (data) => ({
  type: actions.SET_EDIT_BUSINESS_MASTER_NUMBER,
  payload: {
    data
  }
})

export const setNewAddressMailingAddressSame = (isSame) => ({
  type: actions.SET_NEW_ADDRESS_MAILING_ADDRESS_SAME,
  payload: isSame
})

export const setNewMailingAddressProperty = (property, value) => ({
  type: actions.SET_NEW_MAILING_ADDRESS_PROPERTY,
  payload: {
    property,
    value
  }
})

export const setCurrentAddressMedavieDifferentProperty = (property, value) => ({
  type: actions.SET_CURRENT_ADDRESS_MEDAVIE_DIFFERENT,
  payload: {
    property,
    value
  }
})

export const listDeleteAction = (listType, value) => ({
  type: actions.LIST_DELETE,
  payload: {
    listType,
    value
  }
})

export const clearListInfoAction = (listType) => ({
  type: actions.LIST_CLEAR,
  payload: {
    listType
  }
})


export const clearAllAction = () => ({
  type: actions.CLEAR_ALL,
})

export const clearAppDataAction = () => ({
  type: actions.CLEAR_APP_DATA
})
